const config = {
  serverDomain: 'http://dev.tianyancha.com:7004',
  cookieServerSuffix: '.dev.tianyancha.com:7004',
};

module.exports = config;
